module.exports = __webpack_public_path__ + "img/sankaku_28_red.d0b5e37f.png";